// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 250px;
  background-color: #fff;
  color: #2d2f33;
  display: flex;
  flex-direction: column;
  height: 100vh;
  transition: width 0.3s;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.sidebar-top-section {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 90px);
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar.collapsed {
  width: 70px;
  border-right: 1px solid #dcdcdc;
}
.sidebar.collapsed .menu-text,
.sidebar.collapsed .company-name,
.sidebar.collapsed .caption,
.sidebar.collapsed label,
.sidebar.collapsed .sidebar-footer div:not(.user-avatar) {
  display: inline-flex;
}

.company-section {
  text-align: center;
  margin-bottom: 1rem;
}

.company-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-bottom: 0.5rem;
  float: left;
}

.company-name {
  font-size: 14px;
  font-weight: bold;
}

.caption {
  display: block;
  font-size: 12px;
  color: #aaa;
}

.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
}
.menu-list li {
  position: relative;
  margin-bottom: 10px;
}
.menu-list li a {
  display: flex;
  align-items: center;
  padding: 10px;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  transition: background 0.3s;
}
.menu-list li a:hover, .menu-list li a.active {
  background-color: #1571b9;
  color: #fff !important;
}
.menu-list li a:hover i, .menu-list li a.active i {
  color: #fff !important;
}
.menu-list li a i {
  width: 30px;
  text-align: center;
}
.menu-list li a .menu-text {
  margin-left: 10px;
  flex-grow: 1;
}
.menu-list li a .menu-badge {
  background: red;
  border-radius: 10px;
  padding: 0px 6px;
  font-size: 10px;
  margin-left: auto;
}

.collapse-btn {
  cursor: pointer;
  padding: 12px;
  display: flex;
  align-items: center;
  height: 45px;
  background: rgba(179, 220, 244, 0.9411764706);
  text-align: center;
  position: absolute;
  width: 100%;
  bottom: -9px;
}
.collapse-btn i {
  width: 100%;
  text-align: center;
}
.collapse-btn label {
  cursor: pointer;
}

.sidebar-footer {
  border-top: 1px solid #c5e5ff;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.sidebar-footer .user-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.sidebar-footer .user-info .user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
.sidebar-footer .user-info span {
  font-size: 16px;
  text-transform: capitalize;
  display: block;
}
.sidebar-footer .user-info small {
  font-size: 12px;
  display: inline-block;
}
.sidebar-footer .logout {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 0;
}
.sidebar-footer .logout i {
  width: 40px;
  text-align: center;
  transform: rotate(180deg);
}
.sidebar-footer .logout span {
  font-size: 14px;
}

.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.sidebar-overlay.show {
  display: block;
  opacity: 1;
}

@media screen and (max-width: 1024px) and (min-width: 769px) {
  .sidebar {
    width: 220px;
  }
  .sidebar.collapsed {
    width: 70px;
  }
  .sidebar-top-section {
    height: calc(100vh - 100px);
  }
  .company-logo {
    width: 35px;
    height: 35px;
  }
  .menu-list li a {
    padding: 8px;
    font-size: 14px;
  }
}
@media screen and (max-width: 764px) and (min-width: 641px) {
  .sidebar {
    position: relative;
    width: 250px;
    transform: translateX(0) !important;
    display: flex !important;
    height: 100vh;
  }
  .sidebar.collapsed {
    width: 70px;
  }
}
@media screen and (max-width: 640px) and (min-width: 640px) {
  .sidebar {
    background: #ffffff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
    position: fixed;
    width: 280px;
    max-width: 85vw;
    z-index: 999;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    display: flex !important;
    height: 100vh;
  }
  .sidebar.show {
    transform: translateX(0);
  }
  .sidebar.collapsed {
    width: 280px;
    max-width: 85vw;
  }
  .sidebar.collapsed .menu-text,
  .sidebar.collapsed .company-name,
  .sidebar.collapsed .caption,
  .sidebar.collapsed .sidebar-footer div:not(.user-avatar) {
    display: block !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 765px) {
  .sidebar {
    background: #ffffff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
    position: fixed;
    width: 280px;
    max-width: 85vw;
    z-index: 999;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    display: flex !important;
    height: 100vh;
  }
  .sidebar.show {
    transform: translateX(0);
  }
  .sidebar.collapsed {
    width: 280px;
    max-width: 85vw;
  }
  .sidebar.collapsed .menu-text,
  .sidebar.collapsed .company-name,
  .sidebar.collapsed .caption,
  .sidebar.collapsed .sidebar-footer div:not(.user-avatar) {
    display: block !important;
  }
  .sidebar-top-section {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    padding: 15px 10px;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .company-section {
    margin-bottom: 1.5rem;
    padding: 10px 0;
  }
  .company-logo {
    width: 45px;
    height: 45px;
    margin-bottom: 0.75rem;
  }
  .company-name {
    font-size: 16px;
  }
  .caption {
    font-size: 13px;
  }
  .menu-list li {
    margin-bottom: 8px;
  }
  .menu-list li a {
    padding: 12px 10px;
    font-size: 15px;
    border-radius: 6px;
  }
  .menu-list li a i {
    width: 28px;
    font-size: 18px;
  }
  .menu-list li a .menu-text {
    margin-left: 12px;
    font-size: 15px;
  }
  .menu-list li a .menu-badge {
    font-size: 11px;
    padding: 2px 8px;
  }
  .collapse-btn {
    display: none;
  }
  .sidebar-footer {
    padding: 15px 10px;
    border-top: 1px solid #e0e0e0;
  }
  .sidebar-footer .user-info {
    margin-bottom: 12px;
  }
  .sidebar-footer .user-info .user-avatar {
    width: 35px;
    height: 35px;
    margin-right: 12px;
  }
  .sidebar-footer .user-info span {
    font-size: 15px;
  }
  .sidebar-footer .user-info small {
    font-size: 13px;
  }
  .sidebar-footer .logout {
    padding: 10px 0;
    font-size: 15px;
  }
  .sidebar-footer .logout i {
    width: 35px;
    font-size: 18px;
  }
  .sidebar-overlay.show {
    display: block;
  }
}
@media screen and (max-width: 639px) {
  .sidebar {
    background: #ffffff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
    position: fixed;
    width: 280px;
    max-width: 85vw;
    z-index: 999;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    display: flex !important;
    height: 100vh;
  }
  .sidebar.show {
    transform: translateX(0);
  }
  .sidebar.collapsed {
    width: 280px;
    max-width: 85vw;
  }
  .sidebar.collapsed .menu-text,
  .sidebar.collapsed .company-name,
  .sidebar.collapsed .caption,
  .sidebar.collapsed .sidebar-footer div:not(.user-avatar) {
    display: block !important;
  }
  .sidebar-top-section {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    padding: 15px 10px;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .company-section {
    margin-bottom: 1.5rem;
    padding: 10px 0;
  }
  .company-logo {
    width: 45px;
    height: 45px;
    margin-bottom: 0.75rem;
  }
  .company-name {
    font-size: 16px;
  }
  .caption {
    font-size: 13px;
  }
  .menu-list li {
    margin-bottom: 8px;
  }
  .menu-list li a {
    padding: 12px 10px;
    font-size: 15px;
    border-radius: 6px;
  }
  .menu-list li a i {
    width: 28px;
    font-size: 18px;
  }
  .menu-list li a .menu-text {
    margin-left: 12px;
    font-size: 15px;
  }
  .menu-list li a .menu-badge {
    font-size: 11px;
    padding: 2px 8px;
  }
  .collapse-btn {
    display: none;
  }
  .sidebar-footer {
    padding: 15px 10px;
    border-top: 1px solid #e0e0e0;
  }
  .sidebar-footer .user-info {
    margin-bottom: 12px;
  }
  .sidebar-footer .user-info .user-avatar {
    width: 35px;
    height: 35px;
    margin-right: 12px;
  }
  .sidebar-footer .user-info span {
    font-size: 15px;
  }
  .sidebar-footer .user-info small {
    font-size: 13px;
  }
  .sidebar-footer .logout {
    padding: 10px 0;
    font-size: 15px;
  }
  .sidebar-footer .logout i {
    width: 35px;
    font-size: 18px;
  }
  .sidebar-overlay.show {
    display: block;
  }
}
@media screen and (max-width: 639px) {
  .sidebar {
    width: 260px;
    max-width: 80vw;
  }
  .sidebar-top-section {
    height: calc(100vh - 110px);
    padding: 12px 8px;
  }
  .company-logo {
    width: 40px;
    height: 40px;
  }
  .company-name {
    font-size: 15px;
  }
  .menu-list li a {
    padding: 10px 8px;
    font-size: 14px;
  }
  .menu-list li a i {
    width: 26px;
    font-size: 16px;
  }
  .menu-list li a .menu-text {
    margin-left: 10px;
    font-size: 14px;
  }
  .sidebar-footer {
    padding: 12px 8px;
  }
  .sidebar-footer .user-info .user-avatar {
    width: 32px;
    height: 32px;
  }
  .sidebar-footer .user-info span {
    font-size: 14px;
  }
  .sidebar-footer .user-info small {
    font-size: 12px;
  }
}
@media screen and (max-width: 480px) {
  .sidebar {
    width: 240px;
    max-width: 75vw;
  }
  .sidebar-top-section {
    padding: 10px 6px;
  }
  .menu-list li a {
    padding: 9px 6px;
  }
  .menu-list li a .menu-text {
    margin-left: 8px;
  }
}
@media screen and (max-width: 767px) {
  .sp-collapse-wrapper span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EAEA,2CAAA;AAAF;;AAEA;EACG,aAAA;EACD,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,+BAAA;AACF;AAAE;;;;;EAKE,oBAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;AACN;AACM;EAEE,yBAAA;EACA,sBAAA;AAAR;AAEQ;EACE,sBAAA;AAAV;AAIM;EACE,WAAA;EACA,kBAAA;AAFR;AAKM;EACE,iBAAA;EACA,YAAA;AAHR;AAMM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAJR;;AAUA;EACE,eAAA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EAEA,kBAAA;EACA,WAAA;EAEA,YAAA;AATJ;AAWE;EAEE,WAAA;EACA,kBAAA;AAVJ;AAaE;EACE,eAAA;AAXJ;;AAeA;EAEE,6BAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AAbJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAbJ;AAeI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAbN;AAgBI;EACE,eAAA;EACA,0BAAA;EACA,cAAA;AAdN;AAoBI;EACE,eAAA;EAEA,qBAAA;AAnBN;AAuBE;EACE,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,cAAA;AAtBJ;AAwBI;EACE,WAAA;EACA,kBAAA;EAEA,yBAAA;AAvBN;AA0BI;EACE,eAAA;AAxBN;;AA8BA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;AA3BF;AA6BE;EACE,cAAA;EACA,UAAA;AA3BJ;;AAgCA;EACE;IACE,YAAA;EA7BF;EA+BE;IACE,WAAA;EA7BJ;EAiCA;IACE,2BAAA;EA/BF;EAkCA;IACE,WAAA;IACA,YAAA;EAhCF;EAmCA;IACE,YAAA;IACA,eAAA;EAjCF;AACF;AAqCA;EACE;IACE,kBAAA;IACA,YAAA;IACA,mCAAA;IACA,wBAAA;IACA,aAAA;EAnCF;EAqCE;IACE,WAAA;EAnCJ;AACF;AAwCA;EACE;IACE,mBAAA;IACA,yCAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,4BAAA;IACA,sCAAA;IACA,wBAAA;IACA,aAAA;EAtCF;EAwCE;IACE,wBAAA;EAtCJ;EAyCE;IACE,YAAA;IACA,eAAA;EAvCJ;EAyCI;;;;IAIE,yBAAA;EAvCN;AACF;AA6CA;EACE;IACE,mBAAA;IACA,yCAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,4BAAA;IACA,sCAAA;IACA,wBAAA;IACA,aAAA;EA3CF;EA6CE;IACE,wBAAA;EA3CJ;EA8CE;IACE,YAAA;IACA,eAAA;EA5CJ;EA8CI;;;;IAIE,yBAAA;EA5CN;EAiDA;IACE,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;EA/CF;EAkDA;IACE,qBAAA;IACA,eAAA;EAhDF;EAmDA;IACE,WAAA;IACA,YAAA;IACA,sBAAA;EAjDF;EAoDA;IACE,eAAA;EAlDF;EAqDA;IACE,eAAA;EAnDF;EAuDE;IACE,kBAAA;EArDJ;EAuDI;IACE,kBAAA;IACA,eAAA;IACA,kBAAA;EArDN;EAuDM;IACE,WAAA;IACA,eAAA;EArDR;EAwDM;IACE,iBAAA;IACA,eAAA;EAtDR;EAyDM;IACE,eAAA;IACA,gBAAA;EAvDR;EA6DA;IACE,aAAA;EA3DF;EA8DA;IACE,kBAAA;IACA,6BAAA;EA5DF;EA8DE;IACE,mBAAA;EA5DJ;EA8DI;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EA5DN;EA+DI;IACE,eAAA;EA7DN;EAgEI;IACE,eAAA;EA9DN;EAkEE;IACE,eAAA;IACA,eAAA;EAhEJ;EAkEI;IACE,WAAA;IACA,eAAA;EAhEN;EAsEA;IACE,cAAA;EApEF;AACF;AAwEA;EACE;IACE,mBAAA;IACA,yCAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,4BAAA;IACA,sCAAA;IACA,wBAAA;IACA,aAAA;EAtEF;EAwEE;IACE,wBAAA;EAtEJ;EA0EE;IACE,YAAA;IACA,eAAA;EAxEJ;EA2EI;;;;IAIE,yBAAA;EAzEN;EA8EA;IACE,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;EA5EF;EA+EA;IACE,qBAAA;IACA,eAAA;EA7EF;EAgFA;IACE,WAAA;IACA,YAAA;IACA,sBAAA;EA9EF;EAiFA;IACE,eAAA;EA/EF;EAkFA;IACE,eAAA;EAhFF;EAoFE;IACE,kBAAA;EAlFJ;EAoFI;IACE,kBAAA;IACA,eAAA;IACA,kBAAA;EAlFN;EAoFM;IACE,WAAA;IACA,eAAA;EAlFR;EAqFM;IACE,iBAAA;IACA,eAAA;EAnFR;EAsFM;IACE,eAAA;IACA,gBAAA;EApFR;EA0FA;IACE,aAAA;EAxFF;EA2FA;IACE,kBAAA;IACA,6BAAA;EAzFF;EA2FE;IACE,mBAAA;EAzFJ;EA2FI;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EAzFN;EA4FI;IACE,eAAA;EA1FN;EA6FI;IACE,eAAA;EA3FN;EA+FE;IACE,eAAA;IACA,eAAA;EA7FJ;EA+FI;IACE,WAAA;IACA,eAAA;EA7FN;EAmGA;IACE,cAAA;EAjGF;AACF;AAqGA;EACE;IACE,YAAA;IACA,eAAA;EAnGF;EAsGA;IACE,2BAAA;IACA,iBAAA;EApGF;EAuGA;IACE,WAAA;IACA,YAAA;EArGF;EAwGA;IACE,eAAA;EAtGF;EAyGA;IACE,iBAAA;IACA,eAAA;EAvGF;EAyGE;IACE,WAAA;IACA,eAAA;EAvGJ;EA0GE;IACE,iBAAA;IACA,eAAA;EAxGJ;EA4GA;IACE,iBAAA;EA1GF;EA6GI;IACE,WAAA;IACA,YAAA;EA3GN;EA8GI;IACE,eAAA;EA5GN;EA+GI;IACE,eAAA;EA7GN;AACF;AAmHA;EACE;IACE,YAAA;IACA,eAAA;EAjHF;EAoHA;IACE,iBAAA;EAlHF;EAqHA;IACE,gBAAA;EAnHF;EAqHE;IACE,gBAAA;EAnHJ;AACF;AAuHA;EAEI;IACE,aAAA;EAtHJ;AACF","sourcesContent":[".sidebar {\n  width: 250px;\n  background-color: #fff;\n  color: #2d2f33;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  transition: width 0.3s;\n  //padding: 10px;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n}\n.sidebar-top-section{\n   display: flex;\n  flex-direction: column;\n  height:calc(100vh - 90px);\n  padding:10px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.sidebar.collapsed {\n  width: 70px;\n  border-right:1px solid #dcdcdc;\n  .menu-text,\n  .company-name,\n  .caption,\n  label,\n  .sidebar-footer div:not(.user-avatar) {\n    display: inline-flex;\n  }\n}\n\n.company-section {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.company-logo {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  margin-bottom: 0.5rem;\n  float: left;\n}\n\n.company-name {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.caption {\n  display: block;\n  font-size: 12px;\n  color: #aaa;\n}\n\n.menu-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  flex-grow: 1;\n\n  li {\n    position: relative;\n    margin-bottom: 10px;\n\n    a {\n      display: flex;\n      align-items: center;\n      padding: 10px;\n      color: #fff;\n      text-decoration: none;\n      border-radius: 4px;\n      transition: background 0.3s;\n\n      &:hover,\n      &.active {\n        background-color: #1571b9;\n        color: #fff !important;\n\n        i {\n          color: #fff !important;\n        }\n      }\n\n      i {\n        width: 30px;\n        text-align: center;\n      }\n\n      .menu-text {\n        margin-left: 10px;\n        flex-grow: 1;\n      }\n\n      .menu-badge {\n        background: red;\n        border-radius: 10px;\n        padding: 0px 6px;\n        font-size: 10px;\n        margin-left: auto;\n      }\n    }\n  }\n}\n\n.collapse-btn {\n  cursor: pointer;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    height: 45px;\n    background: #b3dcf4f0;\n    text-align: center;\n    // margin-bottom: 10px;\n    position: absolute;\n    width: 100%;\n    // box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    bottom: -9px;\n    // right: -15px;\n  i {\n    // margin-right: 5px;\n    width: 100%;\n    text-align: center;\n  }\n\n  label {\n    cursor: pointer;\n  }\n}\n\n.sidebar-footer {\n  //background: #1473c2;\n  border-top:1px solid #c5e5ff;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n\n  .user-info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n\n    .user-avatar {\n      width: 30px;\n      height: 30px;\n      border-radius: 50%;\n      margin-right: 10px;\n    }\n\n    span {\n      font-size: 16px;\n      text-transform: capitalize;\n      display: block;\n     // color: #fff !important;\n    }\n    .fa-solid,.pi{\n    //  color: #fff !important;\n    }\n    small {\n      font-size: 12px;\n    //  color: #ffffff;\n      display: inline-block;\n    }\n  }\n\n  .logout {\n    display: flex;\n    align-items: center;\n    //color: rgb(255, 255, 255) !important;\n    cursor: pointer;\n    padding: 8px 0;\n\n    i {\n      width: 40px;\n      text-align: center;\n      //margin-right: 10px;\n      transform: rotate(180deg);\n    }\n\n    span {\n      font-size: 14px;\n    }\n  }\n}\n\n// Sidebar overlay for mobile\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 998;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n}\n\n// Tablet styles (769px - 1024px)\n@media screen and (max-width: 1024px) and (min-width: 769px) {\n  .sidebar {\n    width: 220px;\n\n    &.collapsed {\n      width: 70px;\n    }\n  }\n\n  .sidebar-top-section {\n    height: calc(100vh - 100px);\n  }\n\n  .company-logo {\n    width: 35px;\n    height: 35px;\n  }\n\n  .menu-list li a {\n    padding: 8px;\n    font-size: 14px;\n  }\n}\n\n// Medium tablets (641px - 764px) - Always visible sidebar\n@media screen and (max-width: 764px) and (min-width: 641px) {\n  .sidebar {\n    position: relative;\n    width: 250px;\n    transform: translateX(0) !important;\n    display: flex !important;\n    height: 100vh;\n\n    &.collapsed {\n      width: 70px;\n    }\n  }\n}\n\n// Small tablets (640px only) - Mobile behavior\n@media screen and (max-width: 640px) and (min-width: 640px) {\n  .sidebar {\n    background: #ffffff;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n    position: fixed;\n    width: 280px;\n    max-width: 85vw;\n    z-index: 999;\n    top: 0;\n    left: 0;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease-in-out;\n    display: flex !important;\n    height: 100vh;\n\n    &.show {\n      transform: translateX(0);\n    }\n\n    &.collapsed {\n      width: 280px;\n      max-width: 85vw;\n\n      .menu-text,\n      .company-name,\n      .caption,\n      .sidebar-footer div:not(.user-avatar) {\n        display: block !important;\n      }\n    }\n  }\n}\n\n// Medium tablets and small desktops (765px - 768px) - Mobile behavior\n@media screen and (max-width: 768px) and (min-width: 765px) {\n  .sidebar {\n    background: #ffffff;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n    position: fixed;\n    width: 280px;\n    max-width: 85vw;\n    z-index: 999;\n    top: 0;\n    left: 0;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease-in-out;\n    display: flex !important;\n    height: 100vh;\n\n    &.show {\n      transform: translateX(0);\n    }\n\n    &.collapsed {\n      width: 280px;\n      max-width: 85vw;\n\n      .menu-text,\n      .company-name,\n      .caption,\n      .sidebar-footer div:not(.user-avatar) {\n        display: block !important;\n      }\n    }\n  }\n\n  .sidebar-top-section {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 120px);\n    padding: 15px 10px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .company-section {\n    margin-bottom: 1.5rem;\n    padding: 10px 0;\n  }\n\n  .company-logo {\n    width: 45px;\n    height: 45px;\n    margin-bottom: 0.75rem;\n  }\n\n  .company-name {\n    font-size: 16px;\n  }\n\n  .caption {\n    font-size: 13px;\n  }\n\n  .menu-list {\n    li {\n      margin-bottom: 8px;\n\n      a {\n        padding: 12px 10px;\n        font-size: 15px;\n        border-radius: 6px;\n\n        i {\n          width: 28px;\n          font-size: 18px;\n        }\n\n        .menu-text {\n          margin-left: 12px;\n          font-size: 15px;\n        }\n\n        .menu-badge {\n          font-size: 11px;\n          padding: 2px 8px;\n        }\n      }\n    }\n  }\n\n  .collapse-btn {\n    display: none; // Hide collapse button on mobile\n  }\n\n  .sidebar-footer {\n    padding: 15px 10px;\n    border-top: 1px solid #e0e0e0;\n\n    .user-info {\n      margin-bottom: 12px;\n\n      .user-avatar {\n        width: 35px;\n        height: 35px;\n        margin-right: 12px;\n      }\n\n      span {\n        font-size: 15px;\n      }\n\n      small {\n        font-size: 13px;\n      }\n    }\n\n    .logout {\n      padding: 10px 0;\n      font-size: 15px;\n\n      i {\n        width: 35px;\n        font-size: 18px;\n      }\n    }\n  }\n\n  // Show overlay when sidebar is open\n  .sidebar-overlay.show {\n    display: block;\n  }\n}\n\n// Mobile styles (up to 639px)\n@media screen and (max-width: 639px) {\n  .sidebar {\n    background: #ffffff;\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n    position: fixed;\n    width: 280px;\n    max-width: 85vw;\n    z-index: 999;\n    top: 0;\n    left: 0;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease-in-out;\n    display: flex !important;\n    height: 100vh;\n\n    &.show {\n      transform: translateX(0);\n    }\n\n    // On mobile, always show full width when open, ignore collapsed state\n    &.collapsed {\n      width: 280px;\n      max-width: 85vw;\n\n      // Force show menu text and company name on mobile when sidebar is open\n      .menu-text,\n      .company-name,\n      .caption,\n      .sidebar-footer div:not(.user-avatar) {\n        display: block !important;\n      }\n    }\n  }\n\n  .sidebar-top-section {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 120px);\n    padding: 15px 10px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .company-section {\n    margin-bottom: 1.5rem;\n    padding: 10px 0;\n  }\n\n  .company-logo {\n    width: 45px;\n    height: 45px;\n    margin-bottom: 0.75rem;\n  }\n\n  .company-name {\n    font-size: 16px;\n  }\n\n  .caption {\n    font-size: 13px;\n  }\n\n  .menu-list {\n    li {\n      margin-bottom: 8px;\n\n      a {\n        padding: 12px 10px;\n        font-size: 15px;\n        border-radius: 6px;\n\n        i {\n          width: 28px;\n          font-size: 18px;\n        }\n\n        .menu-text {\n          margin-left: 12px;\n          font-size: 15px;\n        }\n\n        .menu-badge {\n          font-size: 11px;\n          padding: 2px 8px;\n        }\n      }\n    }\n  }\n\n  .collapse-btn {\n    display: none; // Hide collapse button on mobile\n  }\n\n  .sidebar-footer {\n    padding: 15px 10px;\n    border-top: 1px solid #e0e0e0;\n\n    .user-info {\n      margin-bottom: 12px;\n\n      .user-avatar {\n        width: 35px;\n        height: 35px;\n        margin-right: 12px;\n      }\n\n      span {\n        font-size: 15px;\n      }\n\n      small {\n        font-size: 13px;\n      }\n    }\n\n    .logout {\n      padding: 10px 0;\n      font-size: 15px;\n\n      i {\n        width: 35px;\n        font-size: 18px;\n      }\n    }\n  }\n\n  // Show overlay when sidebar is open\n  .sidebar-overlay.show {\n    display: block;\n  }\n}\n\n// Small mobile devices (up to 639px) - Additional styles\n@media screen and (max-width: 639px) {\n  .sidebar {\n    width: 260px;\n    max-width: 80vw;\n  }\n\n  .sidebar-top-section {\n    height: calc(100vh - 110px);\n    padding: 12px 8px;\n  }\n\n  .company-logo {\n    width: 40px;\n    height: 40px;\n  }\n\n  .company-name {\n    font-size: 15px;\n  }\n\n  .menu-list li a {\n    padding: 10px 8px;\n    font-size: 14px;\n\n    i {\n      width: 26px;\n      font-size: 16px;\n    }\n\n    .menu-text {\n      margin-left: 10px;\n      font-size: 14px;\n    }\n  }\n\n  .sidebar-footer {\n    padding: 12px 8px;\n\n    .user-info {\n      .user-avatar {\n        width: 32px;\n        height: 32px;\n      }\n\n      span {\n        font-size: 14px;\n      }\n\n      small {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n// Extra small devices (up to 480px)\n@media screen and (max-width: 480px) {\n  .sidebar {\n    width: 240px;\n    max-width: 75vw;\n  }\n\n  .sidebar-top-section {\n    padding: 10px 6px;\n  }\n\n  .menu-list li a {\n    padding: 9px 6px;\n\n    .menu-text {\n      margin-left: 8px;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .sp-collapse-wrapper {\n    span {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
